<template>
  <div>
    <div>
      <NavBarOnly></NavBarOnly>
      <div class="conteudo cor-secundaria-bg" style="position: unset;">
        <logo-empresa></logo-empresa>
        <h5>Realize seu cadastro</h5>
        <p>Seu cadastro poderá ser usado em qualquer parceiro que possua o Sirrus Delivery, tornando seus pedidos mais simples.</p>
        <div class="btn waves-effect waves-light cor-primaria-bg" @click="IniciarCadastro()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              Continuar para cadastrar
            </div>
          </div>
       </div>
       <br>
        <div class="btn waves-effect waves-light cor-primaria-bg" @click="FazerLogin()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              Já tenho cadastro
            </div>
          </div>
       </div>
       <br>
        <div class="btn waves-effect waves-light cor-primaria-bg" @click="ContinuarConvidado()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              Continuar como convidado
            </div>
          </div>
       </div>
       <div style="height: 400px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBarOnly from "../../Widgets/NavBarOnly";
import LogoEmpresa from "../../Widgets/LogoEmpresa";

export default {
  name: "NovoCadastro",
  components: {
    LogoEmpresa,
    NavBarOnly
  },
  mounted() {
     window.scrollTo(0, 0);
  },
  data() {
    return {
      nome:"",
      email:"",
      telefone:"",
    };
  },
  methods: {
    IniciarCadastro() {
      this.$router.push("/" + this.$store.state.empresa_url + "/novo-cadastro");
    },
    FazerLogin() {
      this.$router.push("/" + this.$store.state.empresa_url + "/login");
    },
    ContinuarConvidado() {
      this.$router.push("/" + this.$store.state.empresa_url + "/menu");
    }
  }
};
</script>

<style scoped>
  @import '../../../assets/css/conteudo-splash.css';
</style>



// WEBPACK FOOTER //
// src/components/Paginas/AreaCliente/PreCadastro.vue